import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/messaging";
// Add the Performance Monitoring library
import "firebase/performance";
import "firebase/analytics";

import store from "@/store";

const firebaseConfig = {
  apiKey: "AIzaSyB7v6ByyvuXSzeJs50oImodOpDyLWNdCaA",
  authDomain: "auth.myphotopal.shop",
  databaseURL: "https://travnik-c693b.firebaseio.com",
  projectId: "travnik-c693b",
  storageBucket: "travnik-c693b.appspot.com",
  messagingSenderId: "663034191439",
  appId: "1:663034191439:web:0c2010477078432f52543a",
  measurementId: "G-QKPVBVGZN1",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

firebase.performance();
firebase.analytics();

// firebase utils
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();

// preverimo, ali je podpora za firebase messaging v brskalniku
let messaging = null;
if (firebase.messaging.isSupported()) {
  //console.log("Messaging support is ON");
  messaging = firebaseApp.messaging();
  messaging.usePublicVapidKey(
    "BE0gnFlHPc_66LMFcq0RNhicTxwxk9cezte62a5sn4bndDJOAIymCGq65p1UYt300eMfKF4L43X1AVpxfoBToFw"
  );
}

// firebase collections
const clientsCollection = db.collection("clients");
const usersCollection = db.collection("users");
const usersStatsCollection = db.collection("usersStats");
const deliveryCollection = db.collection("delivery");
const promoCodesCollection = db.collection("promoCodes");
const imageTemplateCollection = db.collection("imageTemplate");
const imageSizeCollection = db.collection("imageSize");
const imageDiscountCollection = db.collection("imageDiscounts");
const paperTypeCollection = db.collection("paperType");
const ordersCollection = db.collection("orders");
const cartCollection = db.collection("cart");
const clientCountersCollection = db.collection("clientCounters");
const promoCodesUsedCollection = db.collection("promoCodesUsed");
const fcmTokensCollection = db.collection("fcmTokens");
const cartWaitingCollection = db.collection("cartWaiting");
const orderDayCollection = db.collection("orderDay");
const orderDayFullCollection = db.collection("orderDayFull");
const roomsCollection = db.collection("rooms");
const orderMonthCollection = db.collection("orderMonth");
const orderMonthFullCollection = db.collection("orderMonthFull");
const giftCategoryCollection = db.collection("giftCategory");
const giftSuperCategoryCollection = db.collection("giftSuperCategory");
const giftCollection = db.collection("gift");
const orderYearCollection = db.collection("orderYear");
const versionCollection = db.collection("version");
const imageDatabaseCategoryCollection = db.collection("imageDatabaseCategory");
const imageDatabaseCollection = db.collection("imageDatabase");
const giftCardCollection = db.collection("giftCard");
const errorCollection = db.collection("error");

firebaseApp.signUp = async (email, password) => {
  try {
    await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        store.commit("setUser", firebase.auth().currentUser);
        store.commit("setIsAuthenticated", true);
      });
    return true;
  } catch (error) {
    store.commit("setUser", {});
    store.commit("setIsAuthenticated", false);
    return error;
  }
};

firebaseApp.signIn = async (email, password) => {
  try {
    await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        store.commit("setUser", firebase.auth().currentUser);
        store.commit("setIsAuthenticated", true);
      });
    return true;
  } catch (error) {
    store.commit("setUser", {});
    store.commit("setIsAuthenticated", false);
    return error;
  }
};

firebaseApp.signInGoogle = async () => {
  try {
    const provider = new firebase.auth.GoogleAuthProvider();
    await firebase
      .auth()
      .signInWithPopup(provider)
      .then(() => {
        store.commit("setUser", firebase.auth().currentUser);
        store.commit("setIsAuthenticated", true);
      });
    return true;
  } catch (error) {
    store.commit("setUser", {});
    store.commit("setIsAuthenticated", false);
    return error;
  }
};

firebaseApp.signInFacebook = async () => {
  try {
    const provider = new firebase.auth.FacebookAuthProvider();
    await firebase
      .auth()
      .signInWithPopup(provider)
      .then(() => {
        store.commit("setUser", firebase.auth().currentUser);
        store.commit("setIsAuthenticated", true);
      });
    return true;
  } catch (error) {
    store.commit("setUser", {});
    store.commit("setIsAuthenticated", false);
    return error;
  }
};

firebaseApp.signOut = async () => {
  try {
    await store.dispatch("setOnline", false);
    await firebase
      .auth()
      .signOut()
      .then(() => {
        // ni potrebno v bistvu commitanje, ker naredimo itak hard reload
        store.commit("setUser", {});
        store.commit("setIsAuthenticated", false);
        store.commit("clearOrderPackages"); // clear real-time handler state
        store.commit("clearModeratorOnline"); // clear real-time handler state
        location.reload();
        return true;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (error) {
    console.log(error);
    return error;
  }
};

firebaseApp.sendNewPassword = async (email) => {
  try {
    await firebase.auth().sendPasswordResetEmail(email);
    return true;
  } catch (error) {
    return error;
  }
};

export {
  db,
  firebaseApp,
  clientsCollection,
  usersCollection,
  usersStatsCollection,
  deliveryCollection,
  promoCodesCollection,
  imageTemplateCollection,
  imageSizeCollection,
  imageDiscountCollection,
  paperTypeCollection,
  ordersCollection,
  cartCollection,
  clientCountersCollection,
  promoCodesUsedCollection,
  fcmTokensCollection,
  storage,
  messaging,
  cartWaitingCollection,
  orderDayCollection,
  orderDayFullCollection,
  roomsCollection,
  orderMonthCollection,
  orderMonthFullCollection,
  giftCategoryCollection,
  giftSuperCategoryCollection,
  giftCollection,
  orderYearCollection,
  versionCollection,
  imageDatabaseCategoryCollection,
  imageDatabaseCollection,
  giftCardCollection,
  errorCollection,
};
